// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__BXDPL","wrapper":"Card_wrapper__Zd9ik","avatar":"Card_avatar__rXlok","percentCard":"Card_percentCard__MazUH","btnSubmit":"Card_btnSubmit__OtwW_"};